module.exports = __webpack_public_path__ + "static/media/id.e8f1c879.svg";